import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const xDropdown = buildProps({
  placement: {
    type: String,
    default: "bottom-start",
  },
} as const);

export type XDropdown = ExtractPropTypes<typeof xDropdown>;
